window.addEventListener(
  "load",
  function () {
    const cartDrawerElement = document.querySelector(".cart-dropdown")
    const options = {
      attributes: true,
    }

    function onCartDrawerVisibilityChange(mutationList, observer) {
      mutationList.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const drawerClass = mutation.target.className
          //console.log("mutation.target.className : ", drawerClass)
          let myTimeout
          if (drawerClass.includes("is-open")) {
            //console.log("cart drawer visible")
            myTimeout = setTimeout(ogAjaxLoad, 0)
          } else {
            //console.log("cart drawer hidden")
            let ogModalElement = document.getElementById("ogInfoModal")
            if (ogModalElement) {
              //console.log("removing ogModalElement")
              ogModalElement.remove()
            }
            if (window.ogOffsetVariantId) {
              let data = {
                id: `${window.ogOffsetVariantId}`,
                quantity: 0,
              }
              jQuery.ajax({
                type: "POST",
                url: "/cart/change.js",
                data: data,
                dataType: "json",
                success: function (res) {
                  //console.log("carbon offset removed : ", res)
                },
              })
            }
            clearTimeout(myTimeout)
          }
        }
      })
    }

    const observer = new MutationObserver(onCartDrawerVisibilityChange)
    observer.observe(cartDrawerElement, options)

    window.showOGModal = function () {
      //console.log("in showOGModal")
      const modal = document.getElementById("ogInfoModal")
      $(modal).fadeIn()
      modal.addEventListener("click", () => {
        $(modal).fadeOut(500)
      })
    }

    window.closeOGModal = function () {
      //console.log("in closeOGModal")
      const modal = document.getElementById("ogInfoModal")
      $(modal).fadeOut(500)
    }

    window.toggleOGOffsetOption = function () {
      let currency = ""
      let totalPrice = 0
      let totalString = $(".cart__total .cart__total__money").text()
      if (totalString) {
        let parts = totalString.split(" ")
        currency = parts[0] || currency
        totalPrice = parts[1] || totalPrice
        totalPrice = Number(totalPrice.replace(/[^0-9.-]+/g, ""))
      }
      const ogOffsetOptionContainer = document.querySelector(
        ".og-carbon-offet-option"
      )
      const ogOffsetOptionSwitch = document.getElementById("og-otion-switch")
      const isOffsetChecked = $(ogOffsetOptionSwitch).is(":checked")
      // console.log("isOffsetChecked : ", isOffsetChecked)
      if (isOffsetChecked) {
        $(ogOffsetOptionContainer).css("opacity", "1")
        window.localStorage.setItem("__OG-item-dismissed", "n")
        // console.log("totalPrice with checked: ", totalPrice)
        let updatedPrice = +(+totalPrice + +window.ogOffsetPrice)
        // console.log("updatedPrice 1 with checked: ", updatedPrice)
        updatedPrice = updatedPrice.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })
        // console.log("updatedPrice 2 with checked: ", updatedPrice)
        $(".cart__total .cart__total__money").text(
          `${currency} ${updatedPrice}`
        )
      } else {
        window.localStorage.setItem("__OG-item-dismissed", "y")
        $(ogOffsetOptionContainer).css("opacity", "0.3")

        let updatedPrice = +(+totalPrice - +window.ogOffsetPrice)
        // console.log("updatedPrice 1 with checked: ", updatedPrice)
        updatedPrice = updatedPrice.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })
        // console.log("updatedPrice 2 with unchecked: ", updatedPrice)
        $(".cart__total .cart__total__money").text(
          `${currency} ${updatedPrice}`
        )
        if (window.ogOffsetVariantId) {
          let data = {
            id: `${window.ogOffsetVariantId}`,
            quantity: 0,
          }
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: data,
            dataType: "json",
            success: function (res) {
              //console.log("carbon offset removed : ", res)
            },
          })
        }
      }
    }

    function ogAjaxLoad() {
      //console.log("in ogAjaxLoad")
      let ogModalHTML = `
              <div id="ogInfoModal" class="og-modal">
                  <div class="og-modal-content">
                      <section class="og-section-main-section">
                          <div class="og-container">
                              <div class="og-section-inner">
                                  <h2>Your Choice Matters:<br> Act Now for a Greener Tomorrow!</h2>
                                  <div class="og-down-sec">
                                      <div class="og-left-sec">
                                          <h3 style="display: inline-flex;">powered by 
                                            <span>
                                            <img src="https://olivegaea.com/logo_white.svg" style="margin-left: 5px;" height="25" width="100" alt="olive gaea">
                                          </span>
                                        </h3>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </section>
                      <div class="og-toward-main-section">
                          <div class="og-container">
                              <div class="og-toward-section">
                                  <h3>Together Towards a Sustainable Future</h3>
                                  <p>We re on a collective mission to foster a carbon-neutral world, and we invite you to be a part of it. Together, we can create lasting change and protect the planet we all call home.</p>
                              </div>
                              <div class="og-toward-section">
                                  <h3>What is Carbon Offsetting?</h3>
                                  <p>Carbon offsetting is a powerful way to balance out the carbon emissions produced during the creation and transportation of products. By supporting projects that reduce or capture greenhouse gas emissions, you can offset the carbon footprint associated with the delivery of your product.</p>
                              </div>
                              <div class="og-toward-section">
                                  <h3>How Does It Work?</h3>
                                  <p>When you choose to pay the Carbon Offsetting Charge, your contribution goes towards verified and impactful carbon offset projects. These projects may include reforestation efforts, renewable energy initiatives, or other environmentally beneficial actions.</p>
                              </div>
                              <a href="#" class="close-og-modal">Sounds Good</a>
                          </div>
                      </div>
                  </div>
              </div>
          `
      let ogModalElement = document.getElementById("ogInfoModal")
      if (!ogModalElement) {
        let ogModalContainerElement = cartDrawerElement.appendChild(
          document.createElement("div")
        )
        ogModalContainerElement.innerHTML = ogModalHTML
      }

      let isOGItemDismissed =
        window.localStorage.getItem("__OG-item-dismissed") === "y"
      let hoursShownSinceOGItemShown = 0
      if (isOGItemDismissed) {
        let dateOGItemShown = window.localStorage.getItem(
          "__OG-item-shown_date"
        )
        if (dateOGItemShown) {
          hoursShownSinceOGItemShown =
            (Date.now() - new Date(dateOGItemShown)) / (1000 * 60 * 60)
        }
      }
      if (isOGItemDismissed && hoursShownSinceOGItemShown < 24) {
        //console.log("not showing carbon offset because of time limit")
        return
      }
      //console.log("hoursShownSinceOGItemShown : ", hoursShownSinceOGItemShown)
      const addOffsetProductInfo = (variantId, description) => {
        let e1 = document.querySelectorAll(".cart-item__content")
        let idx = -1
        e1.forEach((e, i) => {
          if (e.getInnerHTML().includes(variantId)) {
            idx = i
          }
        })
        if (idx > -1) {
          let offsetInfoHTML = `
                      <p class="cart-item__selected-options">
                          <span>${description}</span>
                          <span class="carbon-learn-more" id="ogBtn" onclick="showOGModal()">
                            Learn more
                            <img src="https://d2rlc1umy1oazg.cloudfront.net/images/checkout/bx-chevron-down-1.svg" alt="learn-more" width="24" height="24">
                          </span>
                      </p>
                  `
          let e2 = document.querySelectorAll(".cart-item__meta")[idx]
          e2.innerHTML = offsetInfoHTML
        }
      }

      const showCarbonProdutItem = (
        title,
        description,
        variantImage,
        price
      ) => {
        let itemHTML = `
            <div class="cart-item  cart-item--no-border og-carbon-offet-option">
                <div class="loader cart__loader">
                    <div class="loader-indeterminate">
                    </div>
                </div>
                <div class="cart-item__image">
                    <a href="#">
                        <img class="lazyautosizes ls-is-cached lazyloaded" src=${variantImage} alt="Carbon offset" sizes="90px"/>
                    </a>
                </div>
                <div class="cart-item__content">
                    <div class="cart-item__content-inner">
                        <h4 class="cart-item__title">
                            <a href="#">${title}</a>
                        </h4>
                        <div class="cart-item__meta">
                            <p class="cart-item__selected-options">
                                <span>${description}</span>
                                <span class="carbon-learn-more" id="ogBtn" onclick="showOGModal()">
                                    Learn more
                                    <img src="https://d2rlc1umy1oazg.cloudfront.net/images/checkout/bx-chevron-down-1.svg" alt="learn-more" width="24" height="24">
                                </span>                                                    
                            </p>
                        </div>
                        <a href="#" class="og-swith-container">
                            <label class="og-switch">
                                <input type="checkbox" name="carbon-enable" checked id="og-otion-switch" onclick="toggleOGOffsetOption()">
                                <span class="slider round"></span>
                            </label>
                        </a>
                    </div>
                    <p class="cart__price">
                        <ins>Dhs. ${price}</ins>
                    </p>
                </div>
            </div>
        `
        let cartItemsContainer = document.querySelector(".cart-dropdown__items")
        let e1 = cartItemsContainer.appendChild(document.createElement("div"))
        e1.innerHTML = itemHTML
      }

      $.ajax({
        url: "/products/carbon-offset.js",
        method: "GET",
        cache: false,
        dataType: "JSON",
        contentType: false,
        processData: false,
        success: function (data) {
          if (data && data.id && data.variants && data.variants[0]) {
            const variantId = data.variants[0].id
            const offsetPrice = (data.price / 100).toFixed(2)
            const variantImage = data.images[0]
            const variantTitle = data.title
            const description = data.description
            window.ogOffsetVariantId = variantId
            $.ajax({
              url: "/cart.js",
              method: "GET",
              cache: false,
              dataType: "JSON",
              contentType: false,
              processData: false,
              success: function (response) {
                //console.log(response)
                if (!response || !response.items || !response.items.length) {
                  //console.log("returning for empty basket")
                  return
                }
                const offsetExists = response.items.filter(
                  (e) => e.variant_id === variantId
                ).length
                if (offsetExists) {
                  //console.log("offset already added")
                  addOffsetProductInfo(variantId, description)
                  return
                }
                let drawerBodyItem = cart.cartDropdownBody
                if (
                  drawerBodyItem.innerHTML.includes("og-carbon-offet-option")
                ) {
                  return
                }
                let offsetAdded = false
                let currency = ""
                let totalPrice = 0
                let totalString = $(".cart__total .cart__total__money").text()
                if (totalString) {
                  let parts = totalString.split(" ")
                  currency = parts[0] || currency
                  totalPrice = parts[1] || totalPrice
                  totalPrice = Number(totalPrice.replace(/[^0-9.-]+/g, ""))
                }

                window.ogOffsetPrice = offsetPrice
                data = {
                  id: variantId,
                  quantity: 1,
                }
                jQuery.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  data: data,
                  dataType: "json",
                  success: function () {
                    //console.log("carbon offset added")
                    showCarbonProdutItem(
                      variantTitle,
                      description,
                      variantImage,
                      offsetPrice
                    )
                    window.localStorage.setItem(
                      "__OG-item-shown_date",
                      new Date()
                    )
                    // console.log("totalPrice with checked: ", totalPrice)
                    let updatedPrice = +(+totalPrice + +offsetPrice)
                    // console.log("updatedPrice 1 with checked: ", updatedPrice)
                    updatedPrice = updatedPrice.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                    })
                    // console.log("updatedPrice 1 with checked: ", updatedPrice)
                    $(".cart__total .cart__total__money").text(
                      `${currency} ${updatedPrice}`
                    )
                  },
                })
              },
            })
          }
        },
      })
    }
    // end custom ajax
  },
  false
)
